<template>
  <section class="agent-review-card">
    <div class="side-l">
      <div class="details">
        <p>{{ review.bodyraw }}</p>
      </div>
    </div>
    <div class="side-r">
      <ul class="review-list">
        <li v-if="review.rating > 0" class="score ut-flex ut-content-start ut-items-center">
          <svg-icon class="ut-m-0 ut-mr-2"
                  :icon="'icon-star'"
                  :size="16"
                  :addClass="'ut-text-yellow-400'"></svg-icon>
          {{ review.rating }} / 5
        </li>
        <li v-if="reviewDateTime"
            class="date ut-flex ut-content-start ut-items-center">
          <div class="ut-m-0 ut-mr-2">
          <svg-icon :icon="'icon-watch'"
                    :size="16"
                    :addClass="'ut-text-neutral-400'"></svg-icon>
          </div>
          {{ reviewDateTime }}
        </li>
        <li v-if="reviewLocation"
            class="location ut-flex ut-content-start ut-items-center">
          <div class="ut-m-0 ut-mr-2 ut-text-red-400">
          <svg-icon :icon="'icon-pin'"
                    :size="16"
                    :addClass="''"></svg-icon>
          </div>
          {{ reviewLocation }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'AgentReviewCard',
  components: {
    SvgIcon,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    reviewLocation() {
      if (this.review.authorsuburb || this.review.authorpostcode) {
        return `${this.$options.filters.titleCase(this.review.authorsuburb)} ${this.review.authorpostcode}
          ${this.review.authorstate ? `(${this.review.authorstate})` : ''}`;
      }

      return null;
    },
    reviewDateTime() {
      const reviewDateTime = `${this.review.reviewdate} ${this.review.reviewtime}`;
      return this.$options.filters.formatDate(reviewDateTime);
    },
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .agent-review-card {
    @apply ut-mb-3 ut-overflow-hidden ut-relative;
    box-shadow: 0 1px 2px 0 rgba(36,33,25,0.09), 0 2px 4px 0 rgba(36,33,25,0.17);
    border-radius: 5px;
    background-color: #FFFFFF;
    font-size: 14px;
    line-height: 18px;

    @screen md {
      @apply ut-flex;
    }

    .details {
      @apply ut-ml-0 ut-mb-0;
      font-size: 14px;
      line-height: 18px;
    }


    .side-l {
      @apply ut-py-4 ut-px-4 ut-w-full ut-my-0;
      border-right: 1px solid rgba(151, 151, 151, 0.2);

      @screen md {
        @apply ut-w-2/3 ut-px-6 ut-py-6;
      }
    }

    .side-r {
      @apply ut-w-full ut-pl-6;

      @screen md {
        @apply ut-w-1/3;
      }

      .review-list {

        li {
          @apply ut-my-2;
        }

      }
    }

  }

</style>
